import React from 'react';
import {Images} from '../../../assets';
import {Strings} from '../../../constants';

const AuraHeader = () => {
  return (
    <div className="flex justify-center bg-white border-b border-gray-200">
      <header className="flex items-center justify-between max-w-[80vw] py-4 w-full">
        <div className="flex items-center space-x-2">
          <img alt="Recco Logo" className="w-18 h-auto" src={Images.LOGO} />
        </div>
        <div>
          <button className="bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-medium shadow hover:bg-yellow-500 transition-colors">
            <a href={process.env.REACT_APP_RECCO_MARKETING_URL}>{Strings.DOWNLOAD_RECCO}</a>
          </button>
        </div>
      </header>
    </div>
  );
};

export default AuraHeader;
